import { render, staticRenderFns } from "./onlineExpoVideoList.vue?vue&type=template&id=3bb3b012&"
import script from "./onlineExpoVideoList.vue?vue&type=script&lang=js&"
export * from "./onlineExpoVideoList.vue?vue&type=script&lang=js&"
import style0 from "./onlineExpoVideoList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports